import { render } from "./edit.vue?vue&type=template&id=3d8e82ec&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=3d8e82ec&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8e82ec"],['__file',"src/views/room/roomType/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d8e82ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d8e82ec', __exports__)) {
    console.log('reload')
    api.reload('3d8e82ec', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=3d8e82ec&scoped=true", () => {
    console.log('re-render')
    api.rerender('3d8e82ec', render)
  })

}


export default __exports__